import { render, staticRenderFns } from "./ExportExcelStatisticsDialog.vue?vue&type=template&id=71b1509d&scoped=true"
import script from "./ExportExcelStatisticsDialog.vue?vue&type=script&lang=js"
export * from "./ExportExcelStatisticsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b1509d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71b1509d')) {
      api.createRecord('71b1509d', component.options)
    } else {
      api.reload('71b1509d', component.options)
    }
    module.hot.accept("./ExportExcelStatisticsDialog.vue?vue&type=template&id=71b1509d&scoped=true", function () {
      api.rerender('71b1509d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/ExportExcelStatisticsDialog.vue"
export default component.exports